import { render, staticRenderFns } from "./CreateNewTemplate.vue?vue&type=template&id=5cc5f1b4"
import script from "./CreateNewTemplate.vue?vue&type=script&lang=ts"
export * from "./CreateNewTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports